// utils/loadFonts.js

export const loadFonts = () => {
  const style = document.createElement('style');
  style.type = 'text/css';

  style.textContent = `
    @font-face {
      font-family: 'IranSans';
      src: url('/fonts/BKOODAKO.woff2') format('woff2');
      font-weight: 400;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'IranSans';
      src: url('/fonts/BKOODB.TTF') format('truetype');
      font-weight: 700;
      font-style: normal;
      font-display: swap;
    }

    :root {
      --font-iran-sans: 'IranSans', sans-serif;
    }
  `;

  document.head.appendChild(style);
};
